import { KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

/**
 * Scenes reorder by mouse after 8 px, or by keyboard from a focused scene: Enter picks it up, the arrows move it,
 * Enter or Space drops it, Escape puts it back. Space never picks a scene up: it is the player's play/pause key, and a
 * scene a Space press picked up stayed floating over the timeline, taking the next clicks.
 */
export function useSceneSortSensors() {
  return useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
      keyboardCodes: { start: ['Enter'], cancel: ['Escape'], end: ['Enter', 'Space'] },
    }),
  );
}

export const SCENE_DRAG_ACCESSIBILITY = {
  screenReaderInstructions: {
    draggable: 'To pick up a scene, press Enter. While dragging, use the arrow keys to move it. Press Enter or Space to drop it, or Escape to cancel.',
  },
};
